/**
 * Reference to shape dimension for adjust handler value manipulation
 */
export enum  IReferenceDimension {
    /** Shortest Side */
    SS = "SS",
    /** Width */
    W = "W",
    /** Height */
    H = "H",
    /**
     * Dimension calculation is custom
     * Ref: store/reducers/util.ts: getAdjustHandlerPercentage
     */
    CUSTOM = "CUSTOM",
}
